import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { ServiceSectionsResponse } from "@/api/types";

export function useBusinessServices(slug: string, options: { refetchOnMount?: "always" } = {}) {
  return useQuery({
    queryKey: ["businesses", slug, "services"],
    queryFn: () => api.get(`businesses/${slug}/services`).json<ServiceSectionsResponse>(),
    enabled: !!slug,
    staleTime: 5 * 60_000,
    refetchOnMount: options.refetchOnMount,
  });
}
